import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";

export const ForgotPassword = ({ onClose, defaultEmail = "" }) => {
  const [email, setEmail] = useState(defaultEmail);
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="forgot-password-dialog" className="max-w-md rounded-none border-[#1c1418] bg-white">
        <DialogHeader><DialogTitle className="font-display text-3xl uppercase">Password dimenticata</DialogTitle></DialogHeader>
        {sent ? (
          <p data-testid="forgot-password-sent" className="text-sm leading-relaxed">
            Se l'indirizzo <b>{email}</b> ha un accesso, ti abbiamo inviato un'email con il link per scegliere una nuova password. Il link vale 1 ora.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-6">
            <p className="text-sm">Scrivi la tua email: ti mandiamo un link per scegliere una nuova password.</p>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-password-email"
              className="w-full border-b border-[#1c1418]/30 bg-transparent py-3 text-lg outline-none focus:border-[#1c1418]" />
            {error && <p className="text-sm">{error}</p>}
            <button disabled={busy} data-testid="forgot-password-submit" className="w-full bg-[#1c1418] py-4 font-mono text-xs uppercase tracking-[0.25em] text-white disabled:opacity-60">
              {busy ? "Invio…" : "Inviami il link"}
            </button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
